 

<template>

<!-- <CompanyPolicy></CompanyPolicy> -->

<div class="col-xxl-12 mb-5">

    <!-- <ECShopAdvisory></ECShopAdvisory> -->

  </div>

  <div v-show="loading"> 

 	<el-skeleton :rows="10" animated />

  </div>	

  <div class="container" v-show="!loading && packagetype !== 'BIBO'"> 

    <div class="genealogy-chart-scroll" ref="chartScroll">
      <div class="genealogy-chart-fit-wrapper" :style="chartFitWrapperStyle">
        <div class="genealogy-chart-fit-inner" :style="chartFitStyle">
          <div id="genealogy-pps-chart"></div>
        </div>
      </div>
    </div>

	 

 

	<div  class="card mt-10">

					<div class="card-header cursor-pointer">

						<!--begin::Card title-->

						<div class="card-title m-0">

							<h3 class="fw-bolder m-0"></h3> 

							<!--begin::Actions-->

							<div class="d-flex align-items-center py-1"> 

		

								<button 

									@click="reset();"

									class="btn btn-sm btn-secondary" 

								>

								RESET

								</button>
&nbsp;&nbsp;&nbsp;
								<button 

									@click="confirmPPSSetup(1);"

									class="btn btn-sm btn-primary" 

									v-if="proc==1"

								>

								PROCEED

								</button>  

								<button 

									@click="confirmPPSSetup(2);"

									class="btn btn-sm btn-danger" 

									v-if="proc==2"

								>

								I,CONFIRM THIS STRUCTURE

								</button>  

							</div> 

						</div>  

					</div>  

	</div>

  </div>

   

</template>



<script  >

import { loadGoogleCharts } from 'vue-google-charts'

 

import { ppssetup, ppssetupconfirm} from '@/api/network.api'

import Swal from "sweetalert2/dist/sweetalert2.min.js";  

import {BlockUI} from 'vue-blockui';

import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";

// import CompanyPolicy from "@/components/companypolicy/CompanyPolicy.vue";

// import ECShopAdvisory from "@/views/ECShopAdvisory.vue";



  export default {

    components: {

	//   CompanyPolicy,

	//   ECShopAdvisory

    },

    data () {

      return {

              // Array will be automatically processed with visualization.arrayToDataTable function

			chartData : null, 

			ppsBackground: "#4caf50",

			currentAccount: "",

			emptyNodeBackground: "gray",

			notPPSBackground: "#2196f3",

			loading: true,

			proc: 1,

			children: [],

			downlines: [],

			dragSourceHeadno: null,

			packagetype: "",
			chartScale: 1,
			chartNaturalWidth: 0,
			chartNaturalHeight: 0,
			chartViewportDesktop: true,
			_chartResizeTimer: null

      }

    },

    computed: {
      chartFitStyle() {
        if (!this.chartViewportDesktop) {
          return {};
        }
        const style = {
          transform: 'scale(' + this.chartScale + ')',
          transformOrigin: 'top left'
        };
        if (this.chartNaturalWidth) {
          style.width = this.chartNaturalWidth + 'px';
        }
        return style;
      },
      chartFitWrapperStyle() {
        if (!this.chartNaturalWidth || !this.chartNaturalHeight) {
          return {};
        }
        if (!this.chartViewportDesktop) {
          return {
            width: this.chartNaturalWidth + 'px',
            height: this.chartNaturalHeight + 'px'
          };
        }
        return {
          width: (this.chartNaturalWidth * this.chartScale) + 'px',
          height: (this.chartNaturalHeight * this.chartScale) + 'px',
          margin: '0 auto'
        };
      }
    },

    methods: { 

		 

		reset(){

			this.proc = 1;

			window.location.href =   "/#/networkmenu/ppssetup";

			location.reload();

		},

          drawChart() {

			if (!window.google || !window.google.visualization) return;

			if (!this.downlines[1]) {
				this.loading = false;
				return;
			}

			const chartEl = document.getElementById('genealogy-pps-chart');
			if (!chartEl) return;
			chartEl.innerHTML = '';

			this.chartData = new google.visualization.DataTable();

					this.chartData.addColumn('string', 'Name')

					this.chartData.addColumn('string', 'Manager')

					this.chartData.addColumn('string', 'ToolTip');

			let topaccountdiv = "";

			topaccountdiv = topaccountdiv + '<div class="genealogy-node-content">';
			topaccountdiv = topaccountdiv + this.buildPositionBadge(1);
			topaccountdiv = topaccountdiv + '<div>';
			topaccountdiv = topaccountdiv + '<img src="' +  this.downlines[1].avatar  + '"  style="width:48px; height:48px;">';
			topaccountdiv = topaccountdiv + '</div>';
			topaccountdiv = topaccountdiv +  this.downlines[1].usid + '<br/>';
			topaccountdiv = topaccountdiv + '</div>'; 



			

			this.chartData.addRow(

				[ {v:   "1", f: topaccountdiv } ,'','']   

			); 



			for(let i = 2; i <= 31; i++) {

				let parent = "";

				if(i > 1) {



					if((i % 2) != 0) {

						parent =  (i - 1) / 2; 

					} else { 

						parent =  i / 2;

					}

				}  

 

				let label = "";

				let dragObj = "";

				if(this.downlines[i] !== undefined) {

					dragObj = dragObj + '<div class="genealogy-node-content">';
					dragObj = dragObj + this.buildPositionBadge(i);
					dragObj = dragObj + '<div headno="' + i + '" id="draggable'+ this.downlines[i].usid +'" draggable="true" class="occupied draggable">';
					dragObj = dragObj + '<img src="' +  this.downlines[i].avatar  + '"  style="width:58px; height:58px;">';
					dragObj = dragObj + '</div> <br/>';
					dragObj = dragObj + '</div>';
					label = dragObj;

				} else {

					dragObj = dragObj + '<div class="genealogy-node-content">';
					dragObj = dragObj + this.buildPositionBadge(i);
					dragObj = dragObj + '<div headno="' + i + '" id="draggable'+ i +'" draggable="true" class="draggable pps-drop-slot">';
					dragObj = dragObj + '<span class="pps-drop-hint" aria-hidden="true"></span>';
					dragObj = dragObj + '</div>';
					dragObj = dragObj + '</div>';
					label = dragObj;

				}







				this.chartData.addRow(

					[ {v: i + "", f: label} , parent + "", '']   

				); 

 



				if(this.downlines[i] !== undefined) {

					if(this.downlines[i].isPPS === 1){  

						this.chartData.setRowProperty(i-1, 'style', 'background: ' + this.ppsBackground + ' !important;');	//PPS background 

					}else {

						this.chartData.setRowProperty(i-1, 'style', 'background: ' + this.notPPSBackground + ' !important;');	 //NOT PPS background

					} 

				} else {

					this.chartData.setRowProperty(i-1, 'style', 'background: ' + this.emptyNodeBackground + ' !important;');	 //NOT PPS background

				}



			}

			

            const chart = new google.visualization.OrgChart(chartEl);
			chart.draw(this.chartData, {allowHtml:true, allowCollapse:false, size:'medium' });

			const self = this;
			setTimeout(function() {
				self.fitChartToScreen();
			}, 0);

			new google.visualization.events.addListener(chart, 'select', function() { 

			 

					 

					var selection = chart.getSelection();



					self.children = [];

					if (selection.length > 0) {

					// alert(data.getValue(selection[0].row, 0));

						getChilds(selection[0].row) // start recursive function with selected index 

						console.log(self.children);

					}

					

					function getChilds(index){ // recursive function, adds children of index (row)

						var childs=chart.getChildrenIndexes(index); // get children indexes of current index

						for(var i = 0; i < childs.length;i++){ // for each children 

							var t = self.chartData.getFormattedValue(childs[i],0);    

							let draggable_headno = t.substr(t.indexOf("headno=\"") + 8,t.indexOf("id=\"draggable")-15); 

							if (draggable_headno != "")

							{ 

								if(self.downlines[draggable_headno] !== undefined) { 

									self.children.push({   headno:  draggable_headno}); //id of the draggable 

								}

							}  

							//children.push(data.getValue(childs[i],0)) // add the title

							getChilds(childs[i]) // and call the function with this children index, to get their children and so on >> this is recursive

						}

					}  

			});







			let items = document.querySelectorAll('.draggable');

			items.forEach(function(item) {

				item.addEventListener('dragstart', function(e){

					let dragSrcEl = this;
					const sourceHeadno = parseInt(dragSrcEl.getAttribute("headno"), 10);

					e.dataTransfer.setData("text", String(sourceHeadno));
					self.dragSourceHeadno = sourceHeadno;
					self.children = self.collectDescendants(sourceHeadno);
					self.highlightDropTargets();

				});

				item.addEventListener('dragend', function() {
					self.dragSourceHeadno = null;
					self.clearAllDropHints();
				});

				item.addEventListener('drop', function(e){

					e.preventDefault();
					e.stopPropagation();

					const dragTargetEl = this;
					const targetHeadno = dragTargetEl.getAttribute("headno");
					const sourceHeadno = e.dataTransfer.getData("text");

					self.clearAllDropHints();

					if (!self.applyDrop(sourceHeadno, targetHeadno)) {
						self.drawChart();
						return;
					}

					self.drawChart();

				});

				item.addEventListener('dragenter', function(e) {
					e.preventDefault();

					const targetHeadno = parseInt(this.getAttribute("headno"), 10);
					if (self.downlines[targetHeadno] !== undefined) {
						self.setDropHint(this, 'denied');
					}
				});

				item.addEventListener('dragover', function(e){

					e.preventDefault();

					const targetHeadno = parseInt(this.getAttribute("headno"), 10);
					if (self.canDropAt(self.dragSourceHeadno, targetHeadno)) {
						e.dataTransfer.dropEffect = 'move';
						self.setDropHint(this, 'allowed');
					} else {
						e.dataTransfer.dropEffect = 'none';
						if (self.dragSourceHeadno) {
							self.setDropHint(this, 'denied');
						}
					}

				});

				item.addEventListener('dragleave', function(e) {
					const targetHeadno = parseInt(this.getAttribute("headno"), 10);
					if (self.downlines[targetHeadno] !== undefined) {
						self.setDropHint(this, null);
						return;
					}

					if (self.dragSourceHeadno && self.canDropAt(self.dragSourceHeadno, targetHeadno)) {
						self.setDropHint(this, 'allowed');
					} else if (self.dragSourceHeadno) {
						self.setDropHint(this, 'denied');
					}
				});

			});

		 	

			 this.loading= false;

          },

		  updateChartViewport() {
				this.chartViewportDesktop = window.innerWidth >= 992;
		  },

		  fitChartToScreen() {
				const container = this.$refs.chartScroll;
				const chartEl = document.getElementById('genealogy-pps-chart');
				if (!container || !chartEl) return;

				this.updateChartViewport();
				this.chartScale = 1;
				this.chartNaturalWidth = 0;
				this.chartNaturalHeight = 0;

				const self = this;
				this.$nextTick(function() {
					self.chartNaturalWidth = chartEl.scrollWidth;
					self.chartNaturalHeight = chartEl.scrollHeight;
					if (!self.chartNaturalWidth || !self.chartNaturalHeight) return;

					if (self.chartViewportDesktop) {
						const scaleX = container.clientWidth / self.chartNaturalWidth;
						self.chartScale = +Math.min(scaleX, 1).toFixed(3);
					}
				});
		  },

		  onChartResize() {
				if (this._chartResizeTimer) {
					clearTimeout(this._chartResizeTimer);
				}
				const self = this;
				this._chartResizeTimer = setTimeout(function() {
					self.fitChartToScreen();
				}, 150);
		  },

		  buildPositionBadge(positionNo) {
				return '<span class="genealogy-node-badge">' + positionNo + '</span>';
		  },

		  ensureDropHint(el) {
				let hint = el.querySelector('.pps-drop-hint');
				if (!hint) {
					hint = document.createElement('span');
					hint.className = 'pps-drop-hint';
					hint.setAttribute('aria-hidden', 'true');
					el.appendChild(hint);
				}
				return hint;
		  },

		  setDropHint(el, state) {
				if (!el) return;

				el.classList.remove('pps-drop-allowed', 'pps-drop-denied');
				const hint = this.ensureDropHint(el);

				if (state === 'allowed') {
					el.classList.add('pps-drop-allowed');
					hint.textContent = '+';
					return;
				}

				if (state === 'denied') {
					el.classList.add('pps-drop-denied');
					hint.textContent = '\u00d7';
					return;
				}

				hint.textContent = '';
		  },

		  clearAllDropHints() {
				const self = this;
				document.querySelectorAll('.draggable').forEach(function(item) {
					self.setDropHint(item, null);
				});
		  },

		  highlightDropTargets() {
				const self = this;

				if (!self.dragSourceHeadno) {
					self.clearAllDropHints();
					return;
				}

				document.querySelectorAll('.draggable').forEach(function(item) {
					const targetHeadno = parseInt(item.getAttribute('headno'), 10);
					if (isNaN(targetHeadno)) return;

					if (self.downlines[targetHeadno] !== undefined) {
						self.setDropHint(item, null);
						return;
					}

					if (self.canDropAt(self.dragSourceHeadno, targetHeadno)) {
						self.setDropHint(item, 'allowed');
					} else {
						self.setDropHint(item, 'denied');
					}
				});
		  },

		  collectDescendants(headno) {
				const descendants = [];
				const left = headno * 2;
				const right = headno * 2 + 1;

				if (left <= 31 && this.downlines[left] !== undefined) {
					descendants.push({ headno: left });
					descendants.push.apply(descendants, this.collectDescendants(left));
				}
				if (right <= 31 && this.downlines[right] !== undefined) {
					descendants.push({ headno: right });
					descendants.push.apply(descendants, this.collectDescendants(right));
				}
				return descendants;
		  },

		  getParentPosition(headno) {
				const position = parseInt(headno, 10);
				if (isNaN(position) || position <= 1) return null;
				if (position % 2 === 0) return position / 2;
				return (position - 1) / 2;
		  },

		  getMovedPositions(source) {
				const positions = {};
				const sourceNo = parseInt(source, 10);
				if (isNaN(sourceNo)) return positions;

				positions[sourceNo] = true;
				const descendants = this.collectDescendants(sourceNo);
				for (let i = 0; i < descendants.length; i++) {
					positions[descendants[i].headno] = true;
				}
				return positions;
		  },

		  hasValidUplineForDrop(target, movedPositions) {
				let headno = this.getParentPosition(target);

				while (headno !== null) {
					if (movedPositions[headno]) return false;
					if (this.downlines[headno] === undefined) return false;
					headno = this.getParentPosition(headno);
				}

				return true;
		  },

		  canDropAt(sourceHeadno, targetHeadno) {
				const source = parseInt(sourceHeadno, 10);
				const target = parseInt(targetHeadno, 10);

				if (isNaN(source) || isNaN(target)) return false;
				if (source === target) return false;
				if (this.downlines[target] !== undefined) return false;
				if (this.downlines[source] === undefined || this.downlines[source].isPPS !== 1) return false;

				const movedPositions = this.getMovedPositions(source);
				if (movedPositions[target]) return false;

				return this.hasValidUplineForDrop(target, movedPositions);
		  },

		  applyDrop(sourceHeadno, targetHeadno) {
				const source = parseInt(sourceHeadno, 10);
				const target = parseInt(targetHeadno, 10);

				if (!this.canDropAt(source, target)) return false;

				const snapshot = Object.assign({}, this.downlines);
				const children = this.collectDescendants(source);
				const newstructure = {};

				newstructure[source] = { o: source, n: target };
				this.downlines[target] = this.downlines[source];
				this.downlines[source] = undefined;

				for (let i = 0; i < children.length; i++) {
					let parentHeadno = 0;
					let newArrPos = 0;

					if (children[i].headno % 2 !== 0) {
						parentHeadno = (children[i].headno - 1) / 2;
					} else {
						parentHeadno = children[i].headno / 2;
					}

					if (children[i].headno % 2 !== 0) {
						newArrPos = newstructure[parentHeadno].n;
						newArrPos = (newArrPos * 2) + 1;
					} else {
						newArrPos = newstructure[parentHeadno].n;
						newArrPos = newArrPos * 2;
					}

					newstructure[children[i].headno] = {
						o: children[i].headno,
						n: newArrPos
					};

					if (this.downlines[newArrPos] !== undefined) {
						this.downlines = snapshot;
						return false;
					}

					this.downlines[newArrPos] = this.downlines[children[i].headno];
					this.downlines[children[i].headno] = undefined;
				}

				return true;
		  },

		async getGenealogy(){
					this.loading = true;
					this.downlines = [];

					const response = await ppssetup();

					if (response.data.pps !== undefined && response.data.pps.structure !== undefined) {
						this.currentAccount = response.data.pps.currentAccount;
						const structure = response.data.pps.structure;

						for (let i = 0; i < structure.length; i++) {
							const positionNo = structure[i].positionno != null ? structure[i].positionno : structure[i].positionNo;
							if (positionNo === undefined) continue;

							this.downlines[positionNo] = {
								usid: structure[i].usid,
								isPPS: structure[i].isPPS,
								avatar: structure[i].avatar
							};
						}
					}

					this.drawChart();
		},

		async confirmPPSSetup(proc){ 

				this.loading = true;

				this.proc = proc;



					for(var i = 1; i <=31; i++) {

						if(this.downlines[i] !== undefined) {

							var position = "";

							var uplineno = 0;

							var upline = "";

							if(i % 2 != 0) {

								position =  "R";

								uplineno = (i - 1) /2;

							}else {

								position = "L";

								uplineno = (i) /2;

							}

							

							if(this.downlines[uplineno] !== undefined) { 

								upline  = this.downlines[uplineno].usid ;

							}

							this.downlines[i].position = position;

							this.downlines[i].upid = upline;

						}

					}





				let param = {

					downlines : this.downlines,

					proc: proc	

				};

				const response = await ppssetupconfirm(param); 

				

				this.loading = false;

				if (response.data.result == "SUCCESS") { 

 

    		    	if(proc === 2){ 

						Swal.fire({

							title: "",

							text: response.data.message,

							icon: "success",

							confirmButtonClass: "btn btn-secondary"

						}); 

						return;

    		    	}

					this.proc = 2;

    		    	

    			} else if(response.data.result == "FAILED"){

					Swal.fire({

						title: "",

						text: response.data.message,

						icon: "error",

						confirmButtonClass: "btn btn-secondary"

					}); 

					return;

    			}



		} 



      },

	mounted(){

		setCurrentPageTitle("PPS Setup");

		this.packagetype = localStorage.getItem("packagetype");
		this.updateChartViewport();

		loadGoogleCharts('current', { packages: ['orgchart'] }).then(() => {

			this.getGenealogy();

		});

		window.addEventListener('resize', this.onChartResize);

	},

	beforeUnmount() {

		window.removeEventListener('resize', this.onChartResize);

		if (this._chartResizeTimer) {

			clearTimeout(this._chartResizeTimer);

		}

	},

	watch: { 

      	chartData: function(newVal, oldVal) { // watch it

          console.log('Prop changed: ', newVal, ' | was: ', oldVal)

        }

      }





  }



</script>



<style>

  table {

      border-collapse: inherit;

      border-spacing: 0;

  }

  .google-visualization-orgchart-node {

	  border: 2px solid #8fb2c3 !important;

	  background-color: none !important;

	  background:none !important;

	  overflow: visible !important;

	  position: relative !important;

  }

  .genealogy-node-content {
	  display: inline-block;
	  min-width: 48px;
  }

  .genealogy-node-badge {
	  position: absolute;
	  top: 0;
	  left: 50%;
	  transform: translate(-50%, -50%);
	  width: 20px;
	  height: 20px;
	  min-width: 20px;
	  border-radius: 50%;
	  display: inline-flex;
	  align-items: center;
	  justify-content: center;
	  padding: 0;
	  background: #181c32;
	  color: #fff;
	  font-size: 9px;
	  line-height: 1;
	  font-weight: 600;
	  z-index: 1;
	  box-sizing: border-box;
  }

  .pps-drop-slot {
	  display: flex;
	  align-items: center;
	  justify-content: center;
	  width: 58px;
	  height: 58px;
	  position: relative;
  }

  .draggable {
	  position: relative;
  }

  .pps-drop-hint {
	  display: none;
	  align-items: center;
	  justify-content: center;
	  width: 100%;
	  height: 100%;
	  font-size: 24px;
	  font-weight: 700;
	  line-height: 1;
	  pointer-events: none;
	  z-index: 2;
  }

  .draggable.pps-drop-allowed .pps-drop-hint {
	  display: flex;
	  color: #ffffff;
  }

  .draggable.pps-drop-denied .pps-drop-hint {
	  display: flex;
	  color: #ffffff;
  }

  .draggable.pps-drop-allowed {
	  box-shadow: inset 0 0 0 2px #47be7d;
	  background: rgba(71, 190, 125, 0.35) !important;
  }

  .draggable.pps-drop-denied {
	  box-shadow: inset 0 0 0 2px #f1416c;
	  background: rgba(241, 65, 108, 0.35) !important;
  }

  .draggable.pps-drop-denied img {
	  opacity: 0.35;
  }

  .genealogy-chart-scroll {
    width: 100%;
    max-width: 100%;
    padding-top: 12px;
  }

  @media (max-width: 991.98px) {
    .genealogy-chart-scroll {
      overflow-x: auto;
      overflow-y: visible;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior-x: contain;
    }
  }

  @media (min-width: 992px) {
    .genealogy-chart-scroll {
      overflow: hidden;
    }
  }

  .genealogy-chart-fit-wrapper {
    position: relative;
    overflow: visible;
  }

  .genealogy-chart-fit-inner {
    display: inline-block;
    transform-origin: top left;
    overflow: visible;
  }

  .genealogy-chart-scroll #genealogy-pps-chart,
  .genealogy-chart-scroll #genealogy-pps-chart table {
    overflow: visible;
    max-width: none;
  }

</style>


